// extracted by mini-css-extract-plugin
export default {"content":"favorites_content__amjrv","wrapper":"favorites_wrapper__w9MKp","list":"favorites_list__gutiK"};